import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-global-line text-xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                征途国际
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/60 max-w-xs">
              全球征途，无限可能。征途国际致力于为中国企业提供一站式国际化服务，助力品牌走向世界。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              服务项目
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/services" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">全球市场拓展</Link>
              <Link to="/services" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">跨境业务合作</Link>
              <Link to="/services" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">国际资源对接</Link>
              <Link to="/services" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">国际化战略咨询</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              快速链接
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/articles" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">新闻洞察</Link>
              <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/about#contact" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              联系方式
            </h4>
            <div className="flex flex-col gap-2.5">
              <p className="text-sm text-background-50/60">
                <span className="text-background-50/80">电话：</span>400-888-9999
              </p>
              <p className="text-sm text-background-50/60">
                <span className="text-background-50/80">邮箱：</span>contact@zhengtuguoji.com
              </p>
              <p className="text-sm text-background-50/60">
                <span className="text-background-50/80">地址：</span>北京市朝阳区建国路88号
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 征途国际 Zhengtu International. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}